import React from 'react';
import SEO from './SEO';

const siteUrl = 'https://mangoloops.com';

const getCanonicalUrl = (slug = '/') => {
    const cleanSlug = slug || '/';
    return `${siteUrl}${cleanSlug.startsWith('/') ? cleanSlug : `/${cleanSlug}`}`;
};

const FrontendPageSEO = ({ page, fallbackTitle, fallbackDescription, fallbackKeywords = '', fallbackSlug = '/' }) => {
    const title = page?.meta_title || fallbackTitle;
    const description = page?.meta_desc || fallbackDescription;
    const keywords = page?.meta_keywords || fallbackKeywords;
    const canonical = getCanonicalUrl(page?.slug || fallbackSlug);

    return (
        <SEO
            title={title}
            description={description}
            keywords={keywords}
            canonical={canonical}
            ogTitle={title}
            ogDescription={description}
            ogUrl={canonical}
            twitterTitle={title}
            twitterDescription={description}
        />
    );
};

export default FrontendPageSEO;
